import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import DataExportStatusConstants from '~/constants/data-export-status-constants';
import {
  defaultState,
  setFromResponse,
  setIsLoadingDownloadLink,
  updateIsPollingActive,
} from './data/DataExportCardState';
import { createExportHistoryEntry } from './data/ExportHistoryEntry';
import { getDataExports, getExportDownloadUrl } from './reducer';

export const addDataExportCasesToBuilder = (
  builder: ActionReducerMapBuilder<any>,
  responseKey: string,
  createExport,
  getStatus
) => {
  builder
    .addCase(getDataExports.pending, () => {
      return defaultState;
    })
    .addCase(getDataExports.fulfilled, (state, action) => {
      state = setFromResponse(state, action.payload[responseKey]);
      updateIsPollingActive(state);
    });

  builder
    .addCase(getExportDownloadUrl.pending, (state, action) => {
      setIsLoadingDownloadLink(state, action.meta.arg, true);
    })
    .addCase(getExportDownloadUrl.fulfilled, (state, action) => {
      setIsLoadingDownloadLink(state, action.meta.arg, false);
    })
    .addCase(getExportDownloadUrl.rejected, (state, action) => {
      setIsLoadingDownloadLink(state, action.meta.arg, false);
    });

  builder
    .addCase(createExport.pending, (state) => {
      state.activeExport = createExportHistoryEntry({
        status: DataExportStatusConstants.PENDING,
      });
    })
    .addCase(createExport.fulfilled, (state, action) => {
      state.activeExport = createExportHistoryEntry(action.payload);
      updateIsPollingActive(state);
    })
    .addCase(createExport.rejected, (state) => {
      state.activeExport = createExportHistoryEntry({
        status: DataExportStatusConstants.ERROR,
      });
      updateIsPollingActive(state);
    });

  builder
    .addCase(getStatus.pending, (state) => {
      state.isPollingActive = false;
      delete state.pollingError;
    })
    .addCase(getStatus.fulfilled, (state, action) => {
      state.activeExport = createExportHistoryEntry(action.payload);
      updateIsPollingActive(state);
    })
    .addCase(getStatus.rejected, (state, action) => {
      state.pollingError = action.payload;
    });

  return builder;
};
